export enum ApplicationStep {
  Create,
  Apply,
  PayNow,
  Sign
}
